export default {
  header: {
    logo: 'primary',
    eyebrowLogo: 'primary',
    eyebrowColour: 'dark',
    backgroundColour: 'dark',
    navigationAlignment: 'left'
  },
  siteConfig: {
    search: {
      placeholder: 'Series, Movies, Games...'
    }
  },
  tracking: {
    ampGtmId: 'GTM-NZDN3N5',
    ampGtmEnv: 'gtm_auth=uCwWhqzMY7jwQ2Z9e3Cdfw&gtm_preview=env-2'
  }
};